<template>
  <header>
    <ul><!--
      --><router-link to="/admin/reservations" v-slot="{ href, route, navigate, isActive, isExactActive }">
        <li v-bind:class="[ isExactActive && 'active' ]"><a v-bind:href="href">Réservations</a></li>
      </router-link><!--
      --><router-link to="/admin/bons-cadeaux" v-slot="{ href, route, navigate, isActive, isExactActive }">
        <li v-bind:class="[ isExactActive && 'active' ]"><a v-bind:href="href">Bons cadeaux</a></li>
      </router-link><!--
      --><router-link to="/admin/codes-promos" v-slot="{ href, route, navigate, isActive, isExactActive }">
        <li v-bind:class="[ isExactActive && 'active' ]"><a v-bind:href="href">Codes promos</a></li>
      </router-link><!--
      --><router-link to="/admin/sessions/nestor" v-slot="{ href, route, navigate, isActive, isExactActive }">
        <li v-bind:class="[ isExactActive && 'active' ]"><a v-bind:href="href">NESTOR</a></li>
      </router-link><!--
      --><router-link to="/" v-slot="{ href, route, navigate, isActive, isExactActive }">
        <li v-bind:class="[ isExactActive && 'active' ]" class="headerMenu_reserver"><a v-bind:href="href">Lock Quest</a></li>
      </router-link><!--
    --></ul>
  </header>
</template>

<script>
export default {
  name: "HeaderMenu_Admin"
}
</script>
